import React from 'react'

export default function Preloader() {
    return (
        <div className='preloader-container'>


            <div className='loader'>
                IMS
            </div>

            <div className='preload-text'>
                please wait...
            </div>
        </div>
    )
}
